
import { Grid, Typography, Box, Tooltip } from '@mui/material'
import React from 'react'
import WellnessScore from '../WellnessScore'

import '../../../styles/report.css'

/** 
 * 
 * This component is expecting the following input. 

{
    "Order": "20",
    "ComponentType": "OWS ADMIN DONUT",
    "Visible": "1",
    "OWSLabel": "Overall Wellness Score",
    "HealthAgeLabel": "Health Age",
    "AvgAgeLabel": "AVG. AGE",
    "AvgAgeHelpText": "",
    "HealthAgeHelpText": "<p>Health age is a measure of a person’s physical age, as compared to chronological age. The calculation to determine health age is based on research findings on health and longevity. Each individual receives a health age estimate in their Wellcomplete&reg; Personal Report. These individual ages are averaged to provide you with the health age for your specified population.</p>",
    "OWSHelpText": "<p>The Overall Wellness Score (OWS) evaluates the health of your population and it can be used to measure the effectiveness of your wellness programs. It is based on your population's current health status, lifestyle behaviors, and other factors. A score of 70 or more indicates your population is doing well while a lower score indicates improvement is needed. Each individual receives an OWS in their Wellcomplete&reg; Personal Report based on their personal health information. These individual OWS are averaged to provide you with a population-level OWS.</p>",
    "Value": "0",
    "HealthAgeValue": "0",
    "AvgAgeValue": "0",
    "ValueGrade": "3"
}
*/


const OWSAdminDonut = (props) => {

    return (
        <Grid lg={4} md={4} sm={12} xs={12} justifyContent="center" alignItems="center" sx={{ padding: '10px' }}>
         
                <Grid
                    container
                    direction="row"
                    alignItems="top"
                    justifyContent="center"

                >
                    <Grid item xs={8} >
                        <Box sx={{ maxWidth: "200px" }}>
                            <WellnessScore OWSText={'test'} CurrentOWSValue={Math.floor(parseInt(props.component.Value,0))} />
                        </Box>
                    </Grid>
                    <Grid item xs={12}>
                        <Tooltip title={props.component.HealpText}>
                            <Typography variant="body2" fontWeight="bold" align="center">{props.component.OWSLabel}</Typography>
                        </Tooltip>
                    </Grid>
                </Grid>
          
        </Grid>

    )
}

export default OWSAdminDonut;